import React from 'react';
import classNames from 'classnames';

export type DividerColor = 'regular' | 'subtle' | 'special';
export type DividerSecondColor = 'regular-grey' | 'special-orange';

export type DividerProps = {
  /** "regular", "subtle" or "special", the type options for the divider */
  type?: DividerColor;
  /** an optional prop. by providing a text prop the divider becomes a split divider with text value */
  text?: string;
};

/**
 * A futuro divider
 *
 * @argument type string - "regular", "subtle" or "special", the type options for
 *     the divider
 * @argument text string - an optional prop. by providing a text prop the divider becomes a split divider
 *    with text value
 *
 * Based off the designs in the figma file:
 *
 * https://www.figma.com/file/zYke5qihweC8yQSpXpcRO2/%F0%9F%93%9000-OM-CORE-Library?node-id=2839%3A12379
 *
 * @example
 *
 * <Divider type="regular" />
 * <Divider type="subtle" text="Hello World" />
 * <Divider type="special" text="Hello World" />
 */

const Divider = (props: DividerProps) => {
  const { type = 'regular', text } = props;

  return (
    <div
      className={classNames(
        "flex w-full items-center text-center text-body-small before:flex-[1] before:border-0 before:border-t before:border-solid before:content-[''] after:flex-1 after:border-0 after:border-t after:border-solid after:content-['']",
        {
          'before:border-foreground-regular after:border-foreground-regular text-subtle':
            type === 'regular',
          'before:border-foreground-subtle after:border-foreground-subtle text-regular':
            type === 'subtle',
          'before:border-foreground-special after:border-foreground-special text-primary-brand':
            type === 'special',
        },
        { 'before:mr-s after:ml-s': Boolean(text) }
      )}
    >
      {text || null}
    </div>
  );
};

export default Divider;
